/**
 * Fetch data from given url
 * @param {*} url
 * @param {*} options
 */
const fetchJSON = (url, options = {}) => {
    if(options.headers == null){
        options.headers = {'Content-Type': 'application/json'}
    }
    
    console.log("url: " + url);
    console.log("options: " + JSON.stringify(options));

    return fetch(url, options)
        .then(response => {
            return response.text();
        })
        .then(datas => {
            var json = {};
            if(datas){
                json = JSON.parse(datas);
            }
            
            if(json.error){
                console.log("found error: " + JSON.stringify(json));
                return undefined;
            }else{
                return json;
            }
        })
        .catch(error => {
            console.log("catch error: " + JSON.stringify(error));
            //throw error;
            return error;
        });

    /*
    return fetch(url, options)
        .then(response => {
            console.log("response: " + JSON.stringify(response));
            if (!(response.status === 200 || response.status === 201 || response.status === 204)) {
                console.log("response error: " + JSON.stringify(response));
                // throw response.json();
            }
            return response.json();
        })
        .then(json => {
            return json;
        })
        .catch(error => {
            console.log("catch error: " + JSON.stringify(error));
            //throw error;
        });
        */
        
};

export { fetchJSON };
